'use es6';

import I18n from 'I18n';
import { memo, useEffect } from 'react';
import { TaskSyncBanner } from 'tasks-lib/syncBanner/TaskSyncBanner';
import SavedViewsTaskHeader from '../../components/views/SavedViewsTasksHeader';
import TableHeaderBar from '../../components/views/TableHeaderBar';
import { PAGE_IDS } from '../../constants/pageConfigs';
import { useLoadActiveViewAndRedirectIfNotFound } from '../../hooks/viewTabs';
import { trackTaskSyncBannerDismissed, trackTaskSyncBannerLinkClicked, trackTasksHomePageview } from '../../tracking/tracker';
import GraphQLViewTable from '../table/GraphQLViewTable';
import { setupCsat } from 'wootric-nps/csat/csat-setup';
import { MainContentWrapper } from '../MainContentWrapper';
import { ViewsManagementProvider } from 'customer-data-views-management/providers/ViewsManagementProvider';
import { PinnedViewsBar } from 'customer-data-views-management/pinnedViews/components/PinnedViewsBar';
import { TASK_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useSwitchActiveViewId } from '../../hooks/viewTabs';
import PortalIdParser from 'PortalIdParser';
import UIListingPage from 'UIComponents/page/UIListingPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TEN_SECONDS_MS = 10 * 1000;
const PortalId = PortalIdParser.get();
const TasksHomePage = () => {
  const {
    isLoading: isViewIdLoading,
    activeViewId
  } = useLoadActiveViewAndRedirectIfNotFound();
  useEffect(() => {
    const timeout = setTimeout(() => {
      setupCsat('PROSPECTING_TASKS');
    }, TEN_SECONDS_MS);
    return () => clearTimeout(timeout);
  }, []);
  useEffect(() => {
    if (!isViewIdLoading && activeViewId) {
      trackTasksHomePageview(activeViewId);
    }
  }, [isViewIdLoading, activeViewId]);
  useEffect(() => {
    document.title = I18n.text('crm-tasks-ui.titles.tasks');
  }, []);
  const switchActiveView = useSwitchActiveViewId();
  return /*#__PURE__*/_jsx(UIListingPage, {
    headerComponent: /*#__PURE__*/_jsx(SavedViewsTaskHeader, {
      pageId: PAGE_IDS.TASKS_HOME,
      tabs: /*#__PURE__*/_jsx(ViewsManagementProvider, {
        children: /*#__PURE__*/_jsx(PinnedViewsBar, {
          returnLink: `/tasks/${PortalId}/view/${activeViewId}`,
          currentViewId: String(activeViewId),
          objectTypeId: TASK_TYPE_ID,
          namespace: "TASKS",
          onCurrentViewIdChange: id => switchActiveView(String(id))
        })
      })
    }),
    pageLayout: "full-width",
    children: /*#__PURE__*/_jsxs(MainContentWrapper, {
      paddingBottom: "50px",
      children: [/*#__PURE__*/_jsx(TaskSyncBanner, {
        trackTaskSyncBannerDismissed: trackTaskSyncBannerDismissed,
        trackTaskSyncBannerLinkClicked: trackTaskSyncBannerLinkClicked,
        marginBlockEnd: "400"
      }), /*#__PURE__*/_jsx(TableHeaderBar, {
        viewId: activeViewId
      }), /*#__PURE__*/_jsx(GraphQLViewTable, {
        viewId: activeViewId
      })]
    })
  });
};
export default /*#__PURE__*/memo(TasksHomePage);